module.exports = __webpack_public_path__ + "img/bernardodominic.ba25969c.png";